module.exports = __webpack_public_path__ + "img/1.0300be2d.jpg";